const BASE_URL = "https://backend.pawansutholdings.com";
// const BASE_URL = "http://localhost:3000";

export default BASE_URL;